"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _RowWithShadow = require("../helpers/RowWithShadow");

var _button = require("../button");

var _icons = require("../icons");

var _layout = require("../layout");

var _responsive = require("../responsive");

var _utils = require("../utils");

var _constants = require("./constants");

var _context = require("./context");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var _excluded = ["isSticky", "children", "closeButtonAltText", "closeButtonAriaDescribedBy", "onCloseButtonClick"];
var modalHeaderDefaultProps = {
  closeButtonAltText: 'Close modal',
  isSticky: false
};

var ModalHeader = function ModalHeader(_ref) {
  var _ref$isSticky = _ref.isSticky,
      isSticky = _ref$isSticky === void 0 ? modalHeaderDefaultProps.isSticky : _ref$isSticky,
      children = _ref.children,
      _ref$closeButtonAltTe = _ref.closeButtonAltText,
      closeButtonAltText = _ref$closeButtonAltTe === void 0 ? modalHeaderDefaultProps.closeButtonAltText : _ref$closeButtonAltTe,
      closeButtonAriaDescribedBy = _ref.closeButtonAriaDescribedBy,
      onCloseButtonClick = _ref.onCloseButtonClick,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useModalContext = (0, _context.useModalContext)(),
      headerHasShadow = _useModalContext.headerHasShadow;

  var _useHighZoomLevel = (0, _responsive.useHighZoomLevel)(),
      isInHighZoomLevel = _useHighZoomLevel.isInHighZoomLevel;

  return (0, _core.jsx)(_helperComponents.ModalHeaderRow, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    backgroundColor: _constants.BACKGROUND_COLOR,
    hasShadow: isSticky && !isInHighZoomLevel ? headerHasShadow : false,
    shadowPosition: _RowWithShadow.ShadowPosition.Bottom,
    display: "flex",
    isFooter: false,
    padding: _constants.HEADER_PADDING,
    "data-test-component": "StencilModalHeader"
  }), (0, _core.jsx)(_layout.View, {
    width: _constants.TITLE_WIDTH
  }, children), !!onCloseButtonClick && (0, _core.jsx)(_helperComponents.ModalCloseButton, (0, _extends2.default)({
    dataTestComponent: "ModalCloseButton",
    icon: (0, _core.jsx)(_icons.IconCross, {
      title: closeButtonAltText
    }),
    onClick: onCloseButtonClick,
    variant: _button.ButtonVariant.Tertiary
  }, closeButtonAriaDescribedBy && {
    'aria-describedby': closeButtonAriaDescribedBy
  })));
};

var _default = (0, _utils.composeStencilComponent)({
  baseComponent: ModalHeader,
  description: 'Header of the Modal which contains title and close button.',
  displayName: 'ModalHeader',
  defaultProps: modalHeaderDefaultProps,
  propTypes: {
    children: _stencilReactDesc.PropTypes.node.isRequired.description('Content to display in the modal header.'),
    isSticky: _stencilReactDesc.PropTypes.bool.description('Configure the header to be sticky while scrolling.'),
    closeButtonAltText: _stencilReactDesc.PropTypes.string.description('Alt text used for the close button trailing after the title.'),
    closeButtonAriaDescribedBy: _stencilReactDesc.PropTypes.string.description("Sets the 'aria-describedby' attribute on the close button."),
    onCloseButtonClick: _stencilReactDesc.PropTypes.func.description('Function called when the close button in the modal header is clicked.')
  }
});

exports.default = _default;